import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import GalleryAdd from "./GalleryAdd";
import GalleryMain from "./GalleryMain";
import { utils } from "../../Helpers";
import { galleryService } from '../../Services';
import { Toast } from "../../Components";
export default function Gallery({ cartItem, closeCartPanel, setAuth, setModal, user, NotifModul, profiles, setModalNotification, locationData }) {
  const [tab, setTab] = useState("main");
  const [modalAsset, setModalAsset] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [toastList, setToastList] = useState([]);
  const [rowCount, setRowCount] = useState([]);
  const [galleryList, setGalleryList] = useState([]);
  const [statusUpdated, setStatusUpdated] = useState(false);
  useEffect(() => {
    if (modalAsset) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modalAsset]);
  useEffect(() => {
    setTab("main");
    setPage(1);
    //}, [locationData.key]);
  }, []);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await galleryService.getAll({
          page: page,
          pageSize,
        });
        if (res.success === true) {
          setGalleryList(res.data.data);
          setIsLoaded(true);
          let paginationObj = utils.createPaginationData(res.data);
          setPaginationData(paginationObj);
          setRowCount((res.data.data.length));
        }
        console.log(res.data.data)

      } catch (err) {
        addToast({
          error: true,
          msg: typeof err === 'string'
            ? err.replace(/<[^>]*>/g, '')
            : err.message,
          id: `${Date.now()}-${toastList.length}`
        });
      }
    }
    fetchData();
  }, [page, rowCount, tab, statusUpdated]);
  async function updateStatusImage(id, status) {
    try {
      const res = await galleryService.updateStatus(id, status);
      setStatusUpdated(!statusUpdated)
      addToast({
        error: false,
        msg: res.message,
        id: `${Date.now()}-${toastList.length}`
      });
    } catch (err) {
      addToast({
        error: true,
        msg: typeof err === 'string'
          ? err.replace(/<[^>]*>/g, '')
          : err.message,
        id: `${Date.now()}-${toastList.length}`
      });
    }
  }
  async function deleteImage(id) {
    try {
      const res = await galleryService.delete(id);
      setRowCount((rowCount - 1));
      addToast({
        error: false,
        msg: res.message,
        id: `${Date.now()}-${toastList.length}`
      });
    } catch (err) {
      addToast({
        error: true,
        msg: typeof err === 'string'
          ? err.replace(/<[^>]*>/g, '')
          : err.message,
        id: `${Date.now()}-${toastList.length}`
      });
    }
  }
  const onPaginate = page => {
    setPage(page);
  };
  const addToast = data => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  return (
    <>
      <div className="main">
        <div className="main__inner">
          <GalleryMain
            setTab={setTab}
            setModalAsset={setModalAsset}
            paginationData={paginationData}
            onPaginate={onPaginate}
            isLoaded={isLoaded}
            galleryList={galleryList}
            updateStatusImage={updateStatusImage}
            deleteImage={deleteImage}
          />
          {tab === "add" &&
            <GalleryAdd close={() => setTab("main")}
              setTab={setTab} setToastList={setToastList} toastList={toastList} />}
        </div>
      </div>
      <AnimatePresence>
      </AnimatePresence>
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}